// Society partner list export (CSV + PDF) — V1 implementation only.
import React, { useCallback } from "react";
import CsvDownApi from "../ExportFiles/CsvDownApi";
import PdfDownApi from "../ExportFiles/PdfDownApi";
import { CsvDownApi as CsvDownApiV2, PdfDownApi as PdfDownApiV2 } from "../../v2/integrations/export";
import config from "../../utils/config";

const HEADERS = [
  { label: "Name", key: "name" },
  { label: "Email", key: "email" },
  { label: "Contact", key: "mobileNumber" },
  { label: "Org Name", key: "orgName" },
  { label: "Org Code", key: "orgCode" },
  { label: "VA Number", key: "vaNumber" },
  { label: "Referral ID", key: "referralId" },
  { label: "API Key", key: "apiKey" },
  { label: "Salt", key: "salt" },
  { label: "Program Manager Name", key: "programManagerName" },
  { label: "Program Manager Code", key: "programManagerCode" },
  { label: "Address", key: "address" },
];

const TABLE_HEADER = [
  {
    name: "Name",
    email: "Email",
    mobileNumber: "Contact",
    orgName: "Org Name",
    orgCode: "Org Code",
    vaNumber: "VA Number",
    referralId: "Referral ID",
    apiKey: "API Key",
    salt: "Salt",
    programManagerName: "Program Manager Name",
    programManagerCode: "Program Manager Code",
    address: "Address",
  },
];

const EXPORT_PARAMS = { pagination: { pageNo: 1, pageSize: 10000 } };

function DistributorExportButtons() {
  const getTableBody = useCallback((rows) => {
    return rows.map((item) => ({
      name: item.name,
      email: item.email,
      mobileNumber: item.mobileNumber ?? item.contact ?? "",
      orgName: item.orgName,
      orgCode: item.orgCode,
      vaNumber: item.vaNumber,
      referralId: item.referralId,
      apiKey: item.apiKey,
      salt: item.salt,
      programManagerName: item.programManagerName,
      programManagerCode: item.programManagerCode,
      address: item.address ?? "",
    }));
  }, []);

  return (
    <div className="flex gap10">
      <CsvDownApi
        headers={HEADERS}
        url={`${config.apis.admin.SOCIETY_LIST}`}
        params={EXPORT_PARAMS}
        type="distributor-table"
        title="CSV"
        method="post"
      />
      <PdfDownApi
        tableHeader={TABLE_HEADER}
        getTableBody={getTableBody}
        url={`${config.apis.admin.SOCIETY_LIST}`}
        params={EXPORT_PARAMS}
        heading="Society partner list"
        fileName="society_partner_list"
        method="post"
      />
    </div>
  );
}

export default DistributorExportButtons;
